import Filtros from "@/utils/Filtros";
export default {
  data() {
    return {
      form: {
        filtrosJornada: [],
        filtrosGenero: "",
        filtrosPrograma: "",
        filtrosDependencia: "",
        filtrosOtros: []
      }
    };
  },
  watch: {
    getFiltros: function(val) {
      this.refrescarFiltro(val);
    }
  },
  computed: {
    getFiltros() {
      return this.$store.getters.getFiltros;
    },
    getEstablecimientos() {
      return this.$store.getters.getEstablecimientos;
    },
    filtrosPorTipo() {
      return Filtros.getFiltros();
    }
  },
  beforeMount() {
    this.refrescarFiltro(this.getFiltros);
  },
  //methods
  methods: {
    //emite evento de aplicacion de filtros dando informacion del tipo de categorias y los filtros a aplicar
    aplicarFiltros: function(filtros, tipo) {
      if (filtros == "") {
        return null;
      }
      if (!Array.isArray(filtros)) {
        filtros = [filtros];
      }
      for (let index = 0; index < filtros.length; index++) {
        const element = filtros[index];
        this.$gtag.event("seleccionar-filtros", {
          event_category: "filtros",
          event_label: tipo + "-" + element,
          value: ""
        });
      }
      this.$gtag.event("aplicar-filtros", {
        event_category: "filtros",
        event_label: tipo,
        value: ""
      });
      this.$emit("aplicarFiltros", filtros, tipo);
    },
    //traduce categoria de filtros segun el servicio indicado
    traducirCategorias: function(tipo) {
      return Filtros.traducirCategoria(tipo);
    },
    //traduce filtros segun el servicio indicado
    traducirFiltros: function(filtro) {
      return Filtros.traducirFiltro(filtro);
    },
    refrescarFiltro: function(val) {
      let jornada = val.find(v => v.tipo == "jornadas");
      let genero = val.find(v => v.tipo == "genero");
      let programa = val.find(v => v.tipo == "programa");
      let dependencia = val.find(v => v.tipo == "dependencia");
      let otros = val.find(v => v.tipo == "otros");
      this.form.filtrosJornada = jornada ? [...jornada.filtros] : [];
      this.form.filtrosGenero = genero ? genero.filtros[0] : "";
      this.form.filtrosPrograma = programa ? programa.filtros[0] : "";
      this.form.filtrosDependencia = dependencia ? dependencia.filtros[0] : "";
      this.form.filtrosOtros = otros ? [...otros.filtros] : [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/filtros.js